import { faqs } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于香蕉视频，你可能想了解这些</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center group-open:bg-primary-500 transition-colors">
                  <i className="ri-add-line text-xs text-primary-500 group-open:text-white group-open:rotate-45 transition-all duration-300"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}